import axios from 'axios';
import { serviceUrl } from '../../App';
import { GetBackendUrlForGlobalFunctions } from '../../App';
export const addAssignmentToCapacityElement = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(GetBackendUrlForGlobalFunctions() + `capacity/create`, obj, {
    headers,
  });
};
export const deleteCapacityElement = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(GetBackendUrlForGlobalFunctions() + `capacity/delete`, obj, {
    headers,
  });
};
export default class CapacityServices {}
export const deleteCapacityIDlement = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `capacity/delete_id`,
    obj,
    {
      headers,
    }
  );
};
export const addCapacityNote = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `capacity/add_note`,
    obj,
    {
      headers,
    }
  );
};
